<template lang="pug">
div#PDF(style="width: 772px!important; height:791px;") 
    v-container
        v-row(no-gutters style="background-color:lightyellow;")
            v-col(cols="12" sm="12"  md="12")
                div(align="left"  tile style="border:1px solid lightgray;  padding:10px" )
                    b ANEXO DOCUMENTO - {{DocumentSelect.category}} - N°  {{DocumentSelect.numero}}
        v-row(no-gutters ) 
                v-col(cols="12" sm="12"  md="12") 
                    v-card(style="height: 3px; background-color:var(--SidebarColorBg)" class="pa-2")
        v-row(no-gutters  ) 
            v-col(cols="12" sm="12"  md="12" )                   
                        div(align="center"   tile style="border:1px solid lightgray;")  
                            v-simple-table(dense )
                                    thead(style="background-color:lightgray; color:black!important;")
                                        tr
                                            th(style="color:black!important") N°
                                            th(style="color:black!important") Pregunta
                                            th(style="color:black!important") Respuesta
                                            th(style="color:black!important") Observacion
                                            th(style="color:black!important") Plazo
                                    tbody 
                                        tr
                                            td(style="font-size:12px")  {{item.n}}
                                            td(style="font-size:12px")   {{item.question}}
                                            td(style="font-size:12px")  {{item.answer}}
                                            td(style="padding-left : 3px;  width: 10%;font-size:12px") {{item.observation}}
                                            td(style="font-size:12px")  {{item.dateFinish}} 
                                        tr
                                            td(colspan="5" style="padding:15px" align="center")    
                                                img(height="400" :src="'data:image/png;base64,' + item.img")   
    
    
    
     
</template>
<script>
export default {
    data(){
        return{}
    },
    props:['item','DocumentSelect']
        

     
}
</script>